import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchAllBrief = createAsyncThunk(
  "approvedBrief/fetchAllBrief",
  async ({ page = 1, limit = 10, search }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get("/fetch-all-briefs-admin", {
        params: {
          limit,
          page,
          search,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch briefs");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching briefs"
      );
    }
  }
);

const fetchApprovedBriefSlice = createSlice({
  name: "approvedBrief",
  initialState: {
    items: [],
    totalItems: 0,
    status: "idle",
    error: null,
    loading: false,
    totalBriefs:0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBrief.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchAllBrief.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload.briefs;
        state.totalItems = action.payload.total;
        state.totalBriefs = action.payload.allTotal;
        state.loading = false;
      })
      .addCase(fetchAllBrief.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default fetchApprovedBriefSlice.reducer;
